// Initial state
const state = {
  assets: [
    {
      title: 'Big Buck Bunny',
      format_details: '',
      cfg: {
        source: {
          url: 'https://demo.cf.castlabs.com/public/Transcodes/OUT/TRAN-65/packaging-dashencrypt_encrypt2/Manifest.mpd',
          type: 'application/dash+xml',
          drmProtected: true
        },
        drm: {
          env: 'DRMtoday_STAGING',
          customData: {
            userId: 'purchase',
            sessionId: 'p0',
            merchant: 'six'
          }
        }
      },
      live: false,
      poster: {
        portrait: '//demo.cf.castlabs.com/media/posters/bbb_rodents.jpg',
        landscape: '//demo.cf.castlabs.com/media/posters/bbb_rodents.jpg'
      }
    },
    {
      title: 'MP4 Playback',
      format_details: '',
      cfg: {
        source: {
          url: '//demo.cf.castlabs.com/media/prestomp4/presto.mp4',
          type: 'video/mp4',
          drmProtected: false
        }
      },
      live: false,
      poster: {
        portrait: '',
        landscape: ''
      }
    },
    {
      title: 'Tears of Steel',
      cfg: {
        source: {
          url: 'https://content.players.castlabs.com/tos_1080p_clear/manifest.mpd',
          type: 'application/dash+xml'
        },
        remoteTextTracks: [
          {
            url: '//ams-samplescdn.streaming.mediaservices.windows.net/11196e3d-2f40-4835-9a4d-fc52751b0323/TOS-en.vtt',
            kind: 'subtitles',
            language: 'en',
            mimeType: 'text/vtt',
            label: 'english external vtt track'
          },
          {
            url: '//ams-samplescdn.streaming.mediaservices.windows.net/11196e3d-2f40-4835-9a4d-fc52751b0323/TOS-es.vtt',
            kind: 'subtitles',
            language: 'es',
            mimeType: 'text/vtt',
            label: 'spanish external vtt track'
          },
          {
            url: '//ams-samplescdn.streaming.mediaservices.windows.net/11196e3d-2f40-4835-9a4d-fc52751b0323/TOS-fr.vtt',
            kind: 'subtitles',
            language: 'fr',
            mimeType: 'text/vtt',
            label: 'french external vtt track'
          },
          {
            url: '//ams-samplescdn.streaming.mediaservices.windows.net/11196e3d-2f40-4835-9a4d-fc52751b0323/TOS-it.vtt',
            kind: 'subtitles',
            language: 'it',
            mimeType: 'text/vtt',
            label: 'italian external vtt track'
          },
          {
            url: 'https://raw.githubusercontent.com/Akhilan/malayalam-subtitles/master/Tears%20of%20Steel-%20Mango%20Open%20Movie%20ml.srt',
            kind: 'subtitles',
            language: 'ml',
            mimeType: 'application/x-subrip',
            label: 'malayam external srt track'
          }
        ]
      },
      format_details: '',
      live: false,
      poster: {
        portrait: '//demo.cf.castlabs.com/media/posters/tos.jpg',
        landscape: '//demo.cf.castlabs.com/media/posters/tos.jpg'
      }
    },
    {
      title: 'Super Speedway',
      cfg: {
        source: {
          url: 'https://test.playready.microsoft.com/smoothstreaming/SSWSS720H264/SuperSpeedway_720.ism/manifest',
          type: 'application/vnd.ms-sstr+xml'
        }
      },
      format_details: '',
      url: 'https://test.playready.microsoft.com/smoothstreaming/SSWSS720H264/SuperSpeedway_720.ism/manifest',
      live: false,
      poster: {
        portrait: '//demo.cf.castlabs.com/media/posters/ss.jpg',
        landscape: '//demo.cf.castlabs.com/media/posters/ss.jpg'
      }
    },
    {
      title: 'PRESTOplay (HLS with AAC Audio)',
      cfg: {
        source: {
          url: 'https://demo.cf.castlabs.com/media/prestohls/master.m3u8',
          type: 'application/x-mpegurl'
        }
      },
      format: 'HLS',
      format_details: '',
      live: false,
      poster: {
        portrait: 'https://demo.cf.castlabs.com/media/prestodash/prestoplay_large.jpg',
        landscape: 'https://demo.cf.castlabs.com/media/prestodash/prestoplay_large.jpg'
      }
    },
    {
      title: 'HLS + AES-128',
      cfg: {
        source: {
          url: 'http://demo.cf.castlabs.com/media/HLS/AES128/stream.m3u8',
          type: 'application/x-mpegurl'
        }
      },
      format: 'HLS',
      format_details: '',
      live: false,
      poster: {
        portrait: '//demo.cf.castlabs.com/media/posters/tos.jpg',
        landscape: '//demo.cf.castlabs.com/media/posters/tos.jpg'
      }
    },
    {
      title: 'Akamai Low Latency Stream',
      cfg: {
        source: {
          url: 'https://cmafref.akamaized.net/cmaf/live-ull/2006350/akasource/out.mpd',
          type: 'application/dash+xml'
        },
        autoplay: true,
        muted: true,
        lowLatencyMode: true,
        suggestedPresentationDelay: 1,
        streaming: {
          bufferingGoal: 30,
          rebufferingGoal: 0.2,
          bufferBehind: 10
        }
      },
      format_details: 'CMAF',
      live: true,
      poster: {
        portrait: '',
        landscape: ''
      }
    },
    {
      title: 'Live Sim',
      cfg: {
        source: {
          url: 'https://livesim.dashif.org/livesim/testpic_2s/Manifest.mpd',
          type: 'application/dash+xml'
        }
      },
      format_details: '',
      live: true,
      poster: {
        portrait: '',
        landscape: 'https://storage.googleapis.com/shaka-asset-icons/dash_if_test_pattern.png'
      }
    },
    {
      title: 'Live Sim Thumbs',
      cfg: {
        source: {
          url: 'https://vm2.dashif.org/livesim-dev/testpic_2s/Manifest_thumbs.mpd',
          type: 'application/dash+xml'
        }
      },
      format_details: '',
      live: true,
      poster: {
        portrait: '',
        landscape: 'https://storage.googleapis.com/shaka-asset-icons/dash_if_test_pattern.png'
      }
    },
    {
      title: 'Thumbnails Single JPEGs',
      cfg: {
        source: {
          url: '//demo.cf.castlabs.com/media/Route66/dash/Manifest.mpd',
          type: 'application/dash+xml',
          drmProtected: false
        },
        thumbnails: {
          url: '//demo.cf.castlabs.com/media/Route66/dash/thumbs/$index$.jpg',
          duration: 10,
          preload: [{ step: 60, preloadWhileBuffering: true }, 30, 1]
        }
      },
      format_details: 'Thumbs',
      live: false,
      poster: {
        portrait: '',
        landscape: '//demo.cf.castlabs.com/media/posters/route.jpg'
      }
    },
    {
      title: 'Thumbnails Gridded JPEGs',
      cfg: {
        source: {
          url: '//demo.cf.castlabs.com/media/Route66/dash/Manifest.mpd',
          type: 'application/dash+xml',
          drmProtected: false
        },
        thumbnails: {
          url: '//demo.cf.castlabs.com/media/Route66/dash/thumbs/$index$_7.jpg',
          duration: 10,
          gridSize: '10x10',
          preload: [{ step: 60, preloadWhileBuffering: true }, 30, 1]
        }
      },
      format_details: 'Thumbs',
      live: false,
      poster: {
        portrait: '',
        landscape: '//demo.cf.castlabs.com/media/posters/route.jpg'
      }
    },
    {
      title: 'Thumbnails VTT index',
      cfg: {
        source: {
          url: '//demo.cf.castlabs.com/media/Route66/dash/Manifest.mpd',
          type: 'application/dash+xml',
          drmProtected: false
        },
        thumbnails: {
          url: '//demo.cf.castlabs.com/media/Route66/dash/thumbs/thumbs.vtt',
          preload: [120, 60, 1]
        }
      },
      format_details: 'Thumbs',
      live: false,
      poster: {
        portrait: '',
        landscape: '//demo.cf.castlabs.com/media/posters/route.jpg'
      }
    },
    {
      title: 'Thumbnails BIF',
      cfg: {
        source: {
          url: '//demo.cf.castlabs.com/media/Route66/dash/Manifest.mpd',
          type: 'application/dash+xml',
          drmProtected: false
        },
        thumbnails: {
          url: '//demo.cf.castlabs.com/media/Route66/dash/thumbs/thumbs.bif'
        }
      },
      format_details: 'Thumbs',
      live: false,
      poster: {
        portrait: '',
        landscape: '//demo.cf.castlabs.com/media/posters/route.jpg'
      }
    }
    // {
    //   title: 'IMA (pre/mid/post)',
    //   cfg: {
    //     source: '//demo.cf.castlabs.com/media/prestodash/Manifest.mpd',
    //     ima: {
    //       adTagUrl: '//pubads.g.doubleclick.net/gampad/ads?sz=640x480&' +
    //         'iu=/124319096/external/ad_rule_samples&ciu_szs=300x250&ad_rule=1&' +
    //         'impl=s&gdfp_req=1&env=vp&output=xml_vmap1&unviewed_position_start=1&' +
    //         'cust_params=sample_ar%3Dpremidpostpod%26deployment%3Dgmf-js&cmsid=496&' +
    //         'vid=short_onecue&correlator=' + new Date().getTime()
    //     }
    //   },
    //   format_details: 'Clear MPEG-DASH',
    //   live: false,
    //   poster: {
    //     portrait: '',
    //     landscape: ''
    //   }
    // },
    // {
    //   title: 'IMA (pre+skippable)',
    //   cfg: {
    //     source: '//demo.cf.castlabs.com/media/prestodash/Manifest.mpd',
    //     ima: {
    //       adTagUrl: 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x480&' +
    //         'iu=/124319096/external/single_ad_samples&ciu_szs=300x250&impl=s' +
    //         '&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1' +
    //         '&cust_params=deployment%3Ddevsite%26sample_ct%3Dskippablelinear' +
    //         '&correlator=' + new Date().getTime()
    //     }
    //   },
    //   format_details: 'Clear MPEG-DASH',
    //   live: false,
    //   poster: {
    //     portrait: '',
    //     landscape: ''
    //   }
    // }
    // {
    //   name: 'DASH bbb_with_tiled_thumbnails',
    //   cfg: {
    //     source: 'http://dash.edgesuite.net/akamai/bbb_30fps/bbb_with_tiled_thumbnails.mpd',
    //     thumbnails: {
    //       preload: [{ step: 60, preloadWhileBuffering: true }, 30, 1]
    //     }
    //   }
    // },
    // {
    //   name: 'DASH livestream thumbs',
    //   cfg: {
    //     source: 'http://vm2.dashif.org/livesim-dev/testpic_2s/Manifest_thumbs.mpd'
    //   }
    // },
    // {
    //   name: 'Tears of Steel, DASH, Clear',
    //   cfg: {
    //     source: '//demo.cf.castlabs.com/media/TOS/abr/Manifest_clean_sizes.mpd?v=231'
    //   }
    // },
    // {
    //   name: 'Dolby',
    //   cfg: {
    //     source: '//demo.cf.castlabs.com/media/prestodash/Manifest_safari_test.mpd'
    //   }
    // },
    // {
    //   name: 'thumbs_single',
    //   cfg: {
    //     source: '//demo.cf.castlabs.com/media/Route66/dash/Manifest.mpd',
    //     thumbnails: {
    //       url: '//demo.cf.castlabs.com/media/Route66/dash/thumbs/$index$.jpg',
    //       duration: 10,
    //       preload: [{ step: 60, preloadWhileBuffering: true }, 30, 1]
    //     }
    //   }
    // },
    // {
    //   name: 'thumbs_grid',
    //   cfg: {
    //     source: '//demo.cf.castlabs.com/media/Route66/dash/Manifest.mpd',
    //     thumbnails: {
    //       url: '//demo.cf.castlabs.com/media/Route66/dash/thumbs/$index$_7.jpg',
    //       duration: 10,
    //       gridSize: '10x10',
    //       preload: [{ step: 60, preloadWhileBuffering: true }, 30, 1]
    //     }
    //   }
    // },
    // {
    //   name: 'thumbs_vtt',
    //   cfg: {
    //     source: '//demo.cf.castlabs.com/media/Route66/dash/Manifest.mpd',
    //     thumbnails: {
    //       url: '//demo.cf.castlabs.com/media/Route66/dash/thumbs/thumbs.vtt',
    //       preload: [120, 60, 1]
    //     }
    //   }
    // },
    // {
    //   name: 'thumbs_bif',
    //   cfg: {
    //     source: '//demo.cf.castlabs.com/media/Route66/dash/Manifest.mpd',
    //     thumbnails: {
    //       url: '//demo.cf.castlabs.com/media/Route66/dash/thumbs/thumbs.bif'
    //     }
    //   }
    // },
    // {
    //   name: 'BBB',
    //   cfg: {
    //     source: '//demo.cf.castlabs.com/media/bbb_abr/Manifest.mpd',
    //     drm: {
    //       env: 'DRMtoday_STAGING',
    //       customData: {
    //         merchant: 'client_dev',
    //         assetId: 'BBB_TEST',
    //         userId: 'purchase',
    //         sessionId: 'default'
    //       }
    //     }
    //   }
    // },
    // {
    //   name: 'BBB Wrong merchant',
    //   cfg: {
    //     source: '//demo.cf.castlabs.com/media/bbb_abr/Manifest.mpd',
    //     drm: {
    //       env: 'DRMtoday_STAGING',
    //       customData: {
    //         merchant: 'client_dev_unknown_merchant',
    //         assetId: 'BBB_TEST',
    //         userId: 'purchase',
    //         sessionId: 'default'
    //       }
    //     }
    //   }
    // },
    // {
    //   name: 'DRM with wrong server cert',
    //   cfg: {
    //     source: '//demo.cf.castlabs.com/media/bbb_abr/Manifest.mpd',
    //     drm: {
    //       env: 'DRMtoday_STAGING',
    //       customData: {
    //         merchant: 'client_dev',
    //         assetId: 'BBB_TEST',
    //         userId: 'purchase',
    //         sessionId: 'default'
    //       }
    //     }
    //     // drm: {
    //     //   'com.widevine.alpha': {
    //     //     serverCertificate: new Uint8Array([1, 2, 3])
    //     //   }
    //     // }
    //   }
    // },
    // {
    //   name: 'FPS ',
    //   cfg: {
    //     source: '//demo.cf.castlabs.com/media/fps/prog_index.m3u8',
    //     drm: {
    //       env: 'DRMtoday_STAGING',
    //       customData: {
    //         merchant: 'six',
    //         userId: 'purchase',
    //         sessionId: 'p0'
    //       }
    //     }
    //   }
    // },
    // {
    //   name: 'BBB-Rental',
    //   cfg: {
    //     source: '//demo.cf.castlabs.com/media/bbb_abr/Manifest.mpd',
    //     drm: {
    //       env: 'DRMtoday_STAGING',
    //       customData: {
    //         merchant: 'client_dev',
    //         assetId: 'BBB_TEST',
    //         userId: 'rental2',
    //         sessionId: 'default'
    //       }
    //     }
    //   }
    // },
    // {
    //   name: 'Canal+, SMOOTH, VoD, Clear',
    //   cfg: {
    //     url: '//hss-vod-aka-test.canal-bis.com/ondemand/test/bif/index.ism/Manifest',
    //     type: 'application/vnd.ms-sstr+xml'
    //   }
    // },
    // {
    //   name: 'BBB, SMOOTH, VoD, DRM',
    //   cfg: {
    //     source: {
    //       url: '//demo.cf.castlabs.com/media/msspr/Manifest',
    //       type: 'application/vnd.ms-sstr+xml'
    //     },
    //     drm: {
    //       env: 'DRMtoday_STAGING',
    //       customData: {
    //         userId: 'purchase',
    //         sessionId: 'p0',
    //         merchant: 'six'
    //       }
    //     }
    //   }
    // },
    // {
    //   name: 'ZahsTV, SMOOTH, LIVE, Clear',
    //   cfg: {
    //     source: {
    //       url: '//demo.ss.live.zahs.tv/sd.ism/Manifest',
    //       type: 'application/vnd.ms-sstr+xml'
    //     },
    //     autoplay: true
    //   }
    // },
    // {
    //   name: 'Tears of Steel, SMOOTH, VoD, Clear, Subtitles',
    //   cfg: {
    //     url: '//usp-demo.castlabs.com/video/piff/31245689abb7c52a3d0721447bddd6cd_Tears_Of_Steel.ism/Manifest',
    //     type: 'application/vnd.ms-sstr+xml'
    //   }
    // },
    // {
    //   name: 'Big Buck Bunny: the Dark Truths of a Video Dev Cartoon (HLS, clear)',
    //   cfg: {
    //     url: '//storage.googleapis.com/shaka-demo-assets/bbb-dark-truths-hls/hls.m3u8',
    //     type: 'application/x-mpegurl'
    //   }
    // },
    // {
    //   name: 'Clear, Live HLS',
    //   cfg: {
    //     source: {
    //       url: '//akamai-axtest.akamaized.net/routes/lapd-v1-acceptance/www_c4/Manifest.m3u8',
    //       type: 'application/x-mpegurl'
    //     },
    //     autoplay: true
    //   }
    // },
    // {
    //   name: 'HLS, FairPlay, SingleTS, Media Playlist',
    //   cfg: {
    //     source: {
    //       url: 'https://demo.cf.castlabs.com/media/fps/prog_index.m3u8',
    //       type: 'application/x-mpegurl'
    //     },
    //     autoplay: true,
    //     techOrder: ['clpp_native', 'clpp_html5_mse'],
    //     drm: {
    //       env: 'DRMtoday_STAGING',
    //       customData: {
    //         userId: 'purchase',
    //         sessionId: 'p0',
    //         merchant: 'six'
    //       }
    //     }
    //   }
    // },
    // {
    //   name: 'Direct MP4 file',
    //   cfg: {
    //     source: {
    //       url: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4',
    //       type: 'video/mp4'
    //     },
    //     autoplay: true
    //   }
    // },
    // {
    //   name: 'DASH, Live, SSAI',
    //   cfg: {
    //     source: 'https://564fd68168794875b50e4a43a9e4b8c9.mediatailor.eu-west-1.amazonaws.com/v1/dash/cf6421621b389b384c1fd22e51603ee95db76ae0/dash-debug/out/v1/262264840217463a87d4511cc85a57cc/index.mpd'
    //   }
    // },
    // {
    //   name: 'HLS, Clear',
    //   cfg: {
    //     source: '//castlabs-dl.s3.amazonaws.com/public/Client/Movies/HLS/destiny_hls_clear/destiny.m3u8'
    //   }
    // },
    // {
    //   name: 'QA - Clear VOD DASH (Single period, SegmentBase)',
    //   cfg: {
    //     source: '//demo.cf.castlabs.com/media/prestodash/Manifest.mpd',
    //     autoplay: true
    //   }
    // },
    // {
    //   name: 'QA - Encrypted VOD DASH (Single period, SegmentBase)',
    //   cfg: {
    //     source: '//demo.cf.castlabs.com/media/bbb_abr/Manifest.noMinBufferTime.mpd',
    //     autoplay: true,
    //     drm: {
    //       env: 'DRMtoday_STAGING',
    //       customData: {
    //         userId: 'purchase',
    //         sessionId: 'p0',
    //         merchant: 'six'
    //       }
    //     }
    //   }
    // },
    // {
    //   name: 'QA - Encrypted VOD DASH (Single period, SegmentBase, Multiaudio, Multisubtitles)',
    //   cfg: {
    //     source: '//demo.cf.castlabs.com/media/tos_new/DEMO.mpd?v=2',
    //     autoplay: true,
    //     drm: {
    //       env: 'DRMtoday_STAGING',
    //       customData: {
    //         userId: 'purchase',
    //         sessionId: 'p0',
    //         merchant: 'six'
    //       }
    //     }
    //   }
    // },
    // {
    //   name: 'QA - Encrypted VOD Smooth',
    //   cfg: {
    //     source: {
    //       url: '//demo.cf.castlabs.com/media/msspr/Manifest',
    //       type: 'application/vnd.ms-sstr+xml'
    //     },
    //     autoplay: true,
    //     drm: {
    //       env: 'DRMtoday_STAGING',
    //       customData: {
    //         userId: 'purchase',
    //         sessionId: 'p0',
    //         merchant: 'six'
    //       }
    //     }
    //   }
    // },
    // {
    //   name: 'QA - Encrypted VOD Smooth (Multiaudio, Multisubtitles)',
    //   cfg: {
    //     source: {
    //       url: '//usp-demo.castlabs.com/video/piff/31245689abb7c52a3d0721447bddd6cd_Tears_Of_Steel.ism/Manifest',
    //       type: 'application/vnd.ms-sstr+xml'
    //     },
    //     autoplay: true,
    //     drm: {
    //       env: 'DRMtoday_STAGING',
    //       customData: {
    //         userId: 'purchase',
    //         sessionId: 'p0',
    //         merchant: 'six'
    //       }
    //     }
    //   }
    // },
    // {
    //   name: 'QA - clear VOD HLS',
    //   cfg: {
    //     source: {
    //       url: '//demo.cf.castlabs.com/media/prestohls/master.m3u8',
    //       type: 'application/x-mpegurl'
    //     },
    //     autoplay: true,
    //     techOrder: ['clpp_html5_mse', 'clpp_native'],
    //     drm: {
    //       env: 'DRMtoday_STAGING',
    //       customData: {
    //         userId: 'purchase',
    //         sessionId: 'p0',
    //         merchant: 'six'
    //       }
    //     }
    //   }
    // },
    // {
    //   name: 'QA - encrypted VOD HLS - AES-128',
    //   cfg: {
    //     source: {
    //       url: '//demo.castlabs.com/media/HLS/AES128/stream.m3u8',
    //       type: 'application/x-mpegurl'
    //     },
    //     autoplay: true,
    //     techOrder: ['clpp_html5_mse', 'clpp_native']
    //   }
    // },
    // {
    //   name: 'QA - encrypted VOD HLS - Fairplay',
    //   cfg: {
    //     source: {
    //       url: '//demo.castlabs.com/media/fps/prog_index.m3u8',
    //       type: 'application/x-mpegurl'
    //     },
    //     autoplay: true,
    //     drm: {
    //       env: 'DRMtoday_STAGING',
    //       customData: {
    //         userId: 'purchase',
    //         sessionId: 'p0',
    //         merchant: 'six'
    //       }
    //     }
    //   }
    // },
    // {
    //   name: 'QA - clear VOD HLS (Multiaudio, Multisubtitles)',
    //   cfg: {
    //     source: {
    //       url: '//bitdash-a.akamaihd.net/content/sintel/hls/playlist.m3u8',
    //       type: 'application/x-mpegurl'
    //     },
    //     autoplay: true
    //     // preferredTextLanguage: 'de',
    //     // preferredAudioLanguage: 0
    //   }
    // },
    // {
    //   name: 'QA - MP4 Clear',
    //   cfg: {
    //     source: '//vjs.zencdn.net/v/oceans.mp4',
    //     autoplay: true
    //   }
    // },
    // {
    //   name: 'QA - MP4 Clear without our tech',
    //   cfg: {
    //     source: '//vjs.zencdn.net/v/oceans.mp4',
    //     autoplay: true,
    //     techOrder: ['html5', 'clpp_html5_cast']
    //   }
    // },
    // {
    //   name: 'QA - clear live DASH (Single Period, Segment Template)',
    //   cfg: {
    //     source: 'https://livedash.castlabs.com/livesim/petv/Manifest.mpd',
    //     autoplay: true
    //   }
    // },
    // {
    //   name: 'QA - encrypted live DASH (Single Period, Segment Template)',
    //   cfg: {
    //     source: 'https://livedash.castlabs.com/livesim/petv_drm/Manifest.mpd',
    //     autoplay: true,
    //     drm: {
    //       env: 'DRMtoday_STAGING',
    //       customData: {
    //         userId: 'purchase',
    //         sessionId: 'default',
    //         merchant: 'six'
    //       }
    //     }
    //   }
    // },
    // {
    //   name: 'QA - clear live HLS',
    //   cfg: {
    //     source: {
    //       url: 'http://www.nielseninternet.com/NielsenLiveTest/prog_index.m3u8',
    //       type: 'application/x-mpegurl'
    //     },
    //     autoplay: true
    //   }
    // },
    // {
    //   name: 'QA - clear live Smooth',
    //   cfg: {
    //     source: {
    //       url: 'http://demo.ss.live.zahs.tv/sd.ism/Manifest',
    //       type: 'application/vnd.ms-sstr+xml'
    //     },
    //     autoplay: true
    //   }
    // },
    // {
    //   name: 'QA - 360deg (MP4)',
    //   cfg: {
    //     source: '//demo.castlabs.com/media/360/kolor.mp4',
    //     autoplay: true
    //   }
    // },
    // {
    //   name: 'QA - clear Dolby DASH (Single Period, Segment Template)',
    //   cfg: {
    //     source: 'https://d9zmmjtv72w5o.cloudfront.net/OnDelKits/DDP/Dolby_Digital_Plus_Online_Delivery_Kit_v1.4/Test_Signals/muxed_streams/DASH/Live_MPD/ChID_voices_1280x720p_25fps_h264_multi_lang.mpd',
    //     autoplay: true
    //   }
    // },
    // {
    //   name: 'QA - clear Dolby HLS',
    //   cfg: {
    //     source: 'https://d9zmmjtv72w5o.cloudfront.net/OnDelKits/DDP/Dolby_Digital_Plus_Online_Delivery_Kit_v1.4/Test_Signals/muxed_streams/HLS/Manifest_TS/ChID_voices_1280x720p_25fps_h264_multi_lang.m3u8',
    //     autoplay: true
    //   }
    // },
    // {
    //   name: 'QA - clear Dolby HLS (fragmented MP4)',
    //   cfg: {
    //     source: 'https://d9zmmjtv72w5o.cloudfront.net/OnDelKits/DDP/Dolby_Digital_Plus_Online_Delivery_Kit_v1.4/Test_Signals/muxed_streams/HLS/Manifest_fMP4/ChID_voices_1280x720p_25fps_h264_multi_lang.m3u8',
    //     autoplay: true
    //   }
    // },
    // {
    //   name: 'QA - LSY - clear DASH',
    //   cfg: {
    //     source: 'https://demo.cf.castlabs.com/public/Transcodes/OUT/LHENCODING-156/V1/CA_QA_MPEG_UNPROTECTED/aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee_CA_2018_QA_MPEG_UNPROTECTED/Manifest.mpd',
    //     autoplay: true
    //   }
    // },
    // {
    //   name: 'QA - LSY - clear HLS',
    //   cfg: {
    //     source: 'https://demo.cf.castlabs.com/public/Transcodes/OUT/LHENCODING-156/V1/CA_QA_HLS_UNPROTECTED/aaaaaaaa-bbbb-cccc-dddd-gggggggggggg_CA_2018_QA_HLS_UNPROTECTED/master.m3u8',
    //     autoplay: true
    //   }
    // }
  ]
};

// getters
const getters = {
  asset: (state) => (name) => {
    const s = state.assets.filter((a) => a.name === name);
    if (s && s.length > 0) return s[0];
    return null;
  }
};

// actions
const actions = {
};

// mutations
const mutations = {
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
